export const JOKING_LAUGHING = 'jokingLaughing'
export const PROTECTIVE_CONCERNED = 'protectiveConcerned'
export const CARESS = 'caress'
export const CARESS_REFLECTION = 'caressReflection'
